export class InfoError extends Error {
  constructor(message?: string) {
    super(message);
    this.name = 'Info';
  }
}
